import { render, staticRenderFns } from "./ResizeModal.vue?vue&type=template&id=09015c5e"
import script from "./ResizeModal.vue?vue&type=script&lang=js"
export * from "./ResizeModal.vue?vue&type=script&lang=js"
import style0 from "./ResizeModal.vue?vue&type=style&index=0&id=09015c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports